import { useState, useEffect, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Row,
  Col,
  Layout,
  Select,
  Checkbox,
} from "antd";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

function Constituent() {
  const dispatch = useDispatch();
  const [languageGroup, setLanguageGroup] = useState([]);
  const [curLanguage, setCurLanguage] = useState("L0010");
  const [fixLanguage, setFixLanguage] = useState(false);
  const [sourceDataKor, setSourceDataKor] = useState([]);
  const [sourceDataNative, setSourceDataNative] = useState([]);
  const [editPopup, setEditPopup] = useState([false, {}]);
  const [preNext, setPreNext] = useState([false, false]);
  const [rowIndex, setRowIndex] = useState(null);

  const [rightBox, setRightBox] = useState([false, {}]);
  const [rightBoxPreNext, setRightBoxPreNext] = useState([false, false]);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSizeOptions: [100,200],
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showQuickJumper: true, // page 점프
      hideOnSinglePage: true, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
    },
  });
  const [filter, setFilter] = useState({
    status: "전체",
    dateRange: null,
    search: "",
  });

  const formRef = useRef({});
  const rightFormRef = useRef(null);

  const columns = [
    {
      title: "성분코드",
      dataIndex: "code",
      key: "code",
      width: "100px",
    },
    {
      title: "성분 명칭(한국어)",
      dataIndex: "name",
      key: "name",
      width: "150px",
    },
    {
      title: "색상코드",
      dataIndex: "color",
      key: "color",
      width: "100px",
    },
    {
      title: "처리",
      dataIndex: "",
      width:"100px",
      render: (_, record) => (
        <a
          onClick={(e) => {
            e.stopPropagation();
            const plusNum =
              (tableParams.pagination.current - 1) *
              tableParams.pagination.pageSize;

            if (rightBox[0]) {
              setRightBox([false, {}]);
            }

            if (sourceDataKor.length === 1) {
              setPreNext([true, true]);
            } else if (_.num === 0) {
              setPreNext([true, false]);
            } else if (_.num === sourceDataKor.length - 1) {
              setPreNext([false, true]);
            }

            setRowIndex(_.num - plusNum);
            setEditPopup([true, _]); // reset해도 값을 유지하기 위함
          }}
        >
          수정
        </a>
      ),
    },
    {}
  ];

  const getSourceData = (data) => {
    // console.log(data);
    const data1 = JSON.parse(JSON.stringify(data.data[0]));
    const data2 = JSON.parse(JSON.stringify(data.data[0]));

    const kor = data1.map((ele, idx) => {
      ele.num = idx;
      ele.name = null;
      ele.description = null;
      ele.SystemSettingLanguage_code = "L0010";
      for (let i = 0; i < data.data[1].length; i++) {
        if (
          ele.code === data.data[1][i].code &&
          data.data[1][i].SystemSettingLanguage_code === "L0010"
        ) {
          ele.name = data.data[1][i].name;
          ele.description = data.data[1][i].description;
          ele.SystemSettingLanguage_code =
            data.data[1][i].SystemSettingLanguage_code;
          break;
        }
      }
      return ele;
    });

    const native = data2.map((ele, idx) => {
      ele.num = idx;
      ele.name = null;
      ele.description = null;
      ele.SystemSettingLanguage_code = curLanguage;
      for (let i = 0; i < data.data[1].length; i++) {
        if (
          ele.code === data.data[1][i].code &&
          data.data[1][i].SystemSettingLanguage_code === curLanguage
        ) {
          ele.name = data.data[1][i].name;
          ele.description = data.data[1][i].description;
          ele.SystemSettingLanguage_code =
            data.data[1][i].SystemSettingLanguage_code;
          break;
        }
      }
      return ele;
    });

    const languages = data.data[2].map((el) => {
      return { label: el.name_kor, value: el.code };
    });

    setLanguageGroup(languages);
    setSourceDataKor(kor);
    setSourceDataNative(native);
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: kor.length, //전체 레코드 수(페이지 숫자 표시를 위해 필요)
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const newNum =
      pagination.current * pagination.pageSize - pagination.pageSize;

    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    if (rightBox[0]) {
      setRowIndex(0);
      setCurLanguage(data[newNum].SystemSettingLanguage_code);
      setRightBox([true, data[newNum]]);
      if (newNum === 0) {
        setRightBoxPreNext([true, false]);
      } else if (newNum === data.length - 1) {
        setRightBoxPreNext([false, true]);
      } else {
        setRightBoxPreNext([false, false]);
      }
      rightFormRef.current.setFieldsValue(data[newNum]);
    } else {
      setRowIndex(null);
    }
  };

  const resetValue = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    formRef.current.setFieldsValue(sourceDataKor[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
  };

  const editOkHandler = async () => {
    const value = await formRef.current.validateFields();
    console.log(value);
    axios
      .post(`${backend}/contents/code/edit_constituent`, { value })
      .then((data) => {
        // console.log(data);
        getSourceData(data.data);
        // setSourceData(data.data.data);
        setEditPopup([false, {}]);
        setPreNext([false, false]);
        setRowIndex(null);
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        // if (err.response.status === 401) {
        //   dispatch(authAction(false, null));
        // }
        console.log(err);
        Modal.error({
          title: "수정 실피",
          okText: "확인",
          content:
            "정상적으로 수정되지 않았습니다. 다시 시도하거나 관리자에게 문의해주세요.",
        });
      });
  };

  const editCancelHandler = () => {
    setEditPopup([false, {}]);
    setPreNext([false, false]);
    setRowIndex(null);
  };

  // 이전 버튼 클릭 시 작동 함수
  const preRecord = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    const max = sourceDataKor.length - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setPreNext([false, false]);
    }
    if (preNum === 0) {
      setPreNext([true, false]);
    }

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    formRef.current.resetFields()
    formRef.current.setFieldsValue(sourceDataKor[preNum]);
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecord = () => {
    const nowNum = formRef.current.getFieldValue(["num"]);
    const max = sourceDataKor.length - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setPreNext([false, false]);
    }
    if (nextNum === max) {
      setPreNext([false, true]);
    }

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    formRef.current.resetFields()
    formRef.current.setFieldsValue(sourceDataKor[nextNum]);
  };

  // 형식명칭 validator 함수
  const nameValidator = (_, value) => {
    const code = formRef.current.getFieldValue("code");
    for (let i = 0; i < sourceDataKor.length; i++) {
      if (
        code !== sourceDataKor[i].code &&
        value &&
        value === sourceDataKor[i].name
      ) {
        return Promise.reject(
          new Error(`동일한 성분명칭(한국어) "${value}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  };

  const onRow = (record, rowIdx) => {
    return {
      onClick: () => {
        const data = fixLanguage ? sourceDataNative : sourceDataKor;
        const plusNum =
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize;
        const idx = plusNum + rowIdx;

        if (data.length === 1) {
          setRightBoxPreNext([true, true]);
        } else if (idx === 0) {
          setRightBoxPreNext([true, false]);
        } else if (idx === data.length - 1) {
          setRightBoxPreNext([false, true]);
        } else {
          setRightBoxPreNext([false, false]);
        }
        setRowIndex(rowIdx);
        setCurLanguage(data[idx].SystemSettingLanguage_code);
        setRightBox([true, data[idx]]);
        if (rightBox[0]) {
          rightFormRef.current.setFieldsValue(data[idx]);
        }
      },
    };
  };

  // 여기서부터 오른쪽 영역의 수정박스부분 -------------------------------

  const rightFormNameValidator = (_, value) => {
    const { code, SystemSettingLanguage_code } =
      rightFormRef.current.getFieldsValue();
    const data =
      SystemSettingLanguage_code === "L0010" ? sourceDataKor : sourceDataNative;

    for (let i = 0; i < data.length; i++) {
      if (code !== data[i].code && value && value === data[i].name) {
        return Promise.reject(
          new Error(`동일한 성분명칭 "${value}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  };

  const resetValueRight = () => {
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    rightFormRef.current.setFieldsValue(sourceDataNative[nowNum]); // 리셋을 초기값으로 하지 않고 변경된 현재 데이터로 하기 위함
  };

  const editOkHandlerRight = async () => {
    const value = await rightFormRef.current.validateFields();
    console.log(value);
    axios
      .post(`${backend}/contents/code/edit_constituent`, { value })
      .then((data) => {
        console.log(data);

        getSourceData(data.data);

        // setPreNext([false, false]);
        Modal.success({
          title: "수정 완료",
          okText: "확인",
          content: "정상적으로 수정되었습니다.",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
        console.log(err);
      });
  };

  const editCancelHandlerRight = () => {
    setRightBox([false, {}]);
    setRightBoxPreNext([false, false]);
    setRowIndex(null);
  };

  // // 이전 버튼 클릭 시 작동 함수
  const preRecordRight = () => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    const max = data.length - 1;
    const preNum = nowNum - 1;
    const newPage = parseInt(preNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === max && preNum !== 0) {
      setRightBoxPreNext([false, false]);
    }
    if (preNum === 0) {
      setRightBoxPreNext([true, false]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(preNum - plusNum);
    setCurLanguage(data[preNum].SystemSettingLanguage_code);
    setRightBox([true, data[preNum]]);
    if (rightBox[0]) {
      rightFormRef.current.resetFields()
      rightFormRef.current.setFieldsValue(data[preNum]);
    }
  };

  // 다음 버튼 클릭 시 작동 함수
  const nextRecordRight = () => {
    const data = fixLanguage ? sourceDataNative : sourceDataKor;
    const nowNum = rightFormRef.current.getFieldValue(["num"]);
    const max = data.length - 1;
    const nextNum = nowNum + 1;
    const newPage = parseInt(nextNum / tableParams.pagination.pageSize) + 1;
    const plusNum = (newPage - 1) * tableParams.pagination.pageSize;

    if (nowNum === 0 && nextNum !== max) {
      setRightBoxPreNext([false, false]);
    }
    if (nextNum === max) {
      setRightBoxPreNext([false, true]);
    }
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: newPage,
      },
    });
    setRowIndex(nextNum - plusNum);
    setCurLanguage(data[nextNum].SystemSettingLanguage_code);
    setRightBox([true, data[nextNum]]);
    if (rightBox[0]) {
      rightFormRef.current.resetFields()
      rightFormRef.current.setFieldsValue(data[nextNum]);
    }
  };

  useEffect(() => {
    axios
      .get(`${backend}/contents/code/constituent`)
      .then((data) => {
        getSourceData(data);
      })
      .then((data) => {
        if (rightBox[0]) {
          const num = rightFormRef.current.getFieldValue(["num"]);
          setRightBox([true, sourceDataNative[num]]);
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 401) {
          dispatch(authAction(false, null));
        }
      });
  }, [curLanguage]);

  useEffect(() => {
    if (rightBox[0]) {
      const num = rightFormRef.current.getFieldValue("num");
      // console.log(num)
      // console.log(sourceDataNative)
      rightFormRef.current.setFieldsValue(sourceDataNative[num]);
    }
  }, [sourceDataNative]);

  return (
    <div style={{ display: "flex", flexDirection:"column", height:"100%", overflow: "auto" }}>
      <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
        <Modal
          destroyOnClose={true}
          open={editPopup[0]}
          title="성분코드 수정"
          maskClosable={false}
          onCancel={editCancelHandler}
          footer={
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={resetValue}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecord}
                  disabled={preNext[0]}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  type="primary"
                  onClick={editOkHandler}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  onClick={nextRecord}
                  disabled={preNext[1]}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button onClick={editCancelHandler} icon={<CloseOutlined />}>
                  취소
                </Button>
              </span>
            </div>
          }
        >
          <Form ref={formRef} layout="vertical" initialValues={editPopup[1]}>
            <Form.Item name="code" label="성분코드">
              <Input disabled={true}></Input>
            </Form.Item>
            <Form.Item
              name="SystemSettingLanguage_code"
              label="언어코드"
              hidden={true}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              name="name"
              label="성분명칭(한국어)"
              required={true}
              rules={[
                { required: true, message: "필수 입력사항 입니다." },
                { validator: nameValidator },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item name="description" label="성분설명(한국어)">
              <Input.TextArea></Input.TextArea>
            </Form.Item>
            <Form.Item
              name="color"
              label="색상코드"
              required={true}
              rules={[{ required: true, message: "필수 입력사항 입니다." }]}
            >
              <Input></Input>
            </Form.Item>
          </Form>
        </Modal>

        <Col flex={1} style={{ minWidth: "100px" }}>
          <StyledTable
            onRow={onRow}
            rowClassName={(record, index) => {
              return index === rowIndex ? "selectedRow" : "";
            }}
            columns={columns}
            rowKey="code"
            dataSource={sourceDataKor}
            loading={sourceDataKor.length === 0 ? true : false}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x:100, y:"100%"}}
          />
        </Col>

        {rightBox[0] ? (
          <Col
            flex={0}
            style={{
              minWidth: "500px",
              border: "1px whitesmoke solid",
              marginLeft: "10px",
              overflow: "auto"
            }}
          >
            <div
              style={{
                padding: "10px",
                borderBottom: "1px whitesmoke solid",
                fontWeight: 700,
                fontSize: 17,
                textAlign: "left",
              }}
            >
              번역
            </div>
            <Layout.Content style={{ padding: "10px" }}>
              <Form
                ref={rightFormRef}
                layout="vertical"
                initialValues={rightBox[1]}
              >
                <Form.Item name="code" label="성분코드" hidden={true}>
                  <Input></Input>
                </Form.Item>

                <Form.Item
                  name="SystemSettingLanguage_code"
                  style={{ textAlign: "left" }}
                >
                  <Select
                    defaultValue={fixLanguage ? curLanguage : "L0010"}
                    value={curLanguage}
                    style={{
                      marginRight: "10px",
                      width: 120,
                      textAlign: "left",
                    }}
                    options={languageGroup}
                    onChange={(value) => {
                      setCurLanguage(value);
                    }}
                  />
                  <Checkbox
                    checked={fixLanguage}
                    onChange={(e) => {
                      setFixLanguage(e.target.checked);
                    }}
                  >
                    언어고정
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name="name"
                  label="성분명칭"
                  style={{ textAlign: "left" }}
                  required={true}
                  rules={[
                    { required: true, message: "필수 입력사항 입니다." },
                    { validator: rightFormNameValidator },
                  ]}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item name="description" label="성분설명">
                  <Input.TextArea
                    style={{ minHeight: "250px" }}
                  ></Input.TextArea>
                </Form.Item>
              </Form>
            </Layout.Content>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "10px",
                borderTop: "1px whitesmoke solid",
              }}
            >
              <Button onClick={resetValueRight}>내용 초기화</Button>
              <span>
                <Button
                  onClick={preRecordRight}
                  disabled={rightBoxPreNext[0]}
                  icon={<LeftOutlined />}
                >
                  이전
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  type="primary"
                  onClick={editOkHandlerRight}
                  icon={<CheckOutlined />}
                >
                  수정
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={nextRecordRight}
                  disabled={rightBoxPreNext[1]}
                  icon={<RightOutlined />}
                >
                  다음
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  onClick={editCancelHandlerRight}
                  icon={<CloseOutlined />}
                >
                  취소
                </Button>
              </span>
            </div>
          </Col>
        ) : null}
      </div>
    </div>
  );
}

export default Constituent;
